// extracted by mini-css-extract-plugin
export default {"login":"Login_login__9QHXK","form":"Login_form__Yp4pC","input":"Login_input__Sh999","actions":"Login_actions__E01+g","info":"Login_info__y8jQ+"};